export default
{
    API_URL: process.env.VUE_APP_API_URL,
    TIMEOUT: 60 * 15, // 15 minutes
    TIMER: 'timer' //used to specify the name of the variable for timeout in local storage
}